import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LocalizationManagerService {

  constructor(private translateService:TranslateService) { }

  localizationStorageKey  = 'loc';
  defaultLocalizationValue = 'pl-PL';

  getCurrentLocalization(){
    const localization = localStorage.getItem(this.localizationStorageKey);

    if(localization == undefined || !localization){
      return this.defaultLocalizationValue;
    }
    return localization;
  }

  getCurrentLocalizationKey(){
   return  this.getCurrentLocalization().substring(0,2);
  }


  setCurrentLocalization(newLocalization:string){
    // if(newLocalization == localization){
    //   return;
    // }

      localStorage.setItem(this.localizationStorageKey, newLocalization);

    const translateLocalizationKey = newLocalization.substring(0,2);
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translateService.setDefaultLang(translateLocalizationKey);

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translateService.use(translateLocalizationKey);
    }

    initializeLocalization(){
      this.setCurrentLocalization(this.getCurrentLocalization())
    }
  }

